import { httpClient, prop } from 'common-utils';
import { z } from 'zod';

const Location = z.object({
  city: z.string().optional(),
  country_code: z.string(),
  country_name: z.string().optional(),
  expiry: z.number().optional(),
  ip: z.string().optional(),
  latitude: z.number().optional(),
  longitude: z.number().optional(),
  metro_code: z.number().optional(),
  region_code: z.string().optional(),
  region_name: z.string().optional(),
  time_zone: z.string().optional(),
  zip_code: z.string().optional(),
});
export type geoType = z.infer<typeof Location>;

export function getCountryCode(): Promise<string> {
  if (typeof window !== 'undefined') {
    const geoIp = localStorage.getItem('geoip');
    if (geoIp && new Date().getTime() < JSON.parse(geoIp).expiry) {
      const clientAddress = JSON.parse(geoIp);
      return Promise.resolve(clientAddress.country_code);
    }
  }

  return httpClient
    .get('https://geoip.cactusglobal.io/json/')
    .then(Location.parse)
    .then((data) => {
      const expire = new Date();
      const time = Date.now() + 3600 * 1000 * 24;
      expire.setTime(time);
      data.expiry = expire.getTime();
      if (!data.country_code) {
        data.country_code = 'US';
      }
      localStorage.setItem('geoip', JSON.stringify(data));
      return data;
    })
    .then(prop('country_code'))
    .catch((error) => {
      console.error('Error fetching country code:', error);
      return 'US'; // Return default value 'US' in case of error
    });
}

export function getCountryCodeAllInfo(): Promise<geoType> {
  if (typeof window !== 'undefined') {
    const geoIp = localStorage.getItem('geoip');
    if (geoIp && new Date().getTime() < JSON.parse(geoIp).expiry) {
      const clientAddress = JSON.parse(geoIp);
      return Promise.resolve(clientAddress);
    }
  }

  return httpClient
    .get('https://geoip.cactusglobal.io/json/')
    .then(Location.parse)
    .then((data) => {
      const expire = new Date();
      const time = Date.now() + 3600 * 1000 * 24;
      expire.setTime(time);
      data.expiry = expire.getTime();
      if (!data.country_code) {
        data.country_code = 'US';
      }
      localStorage.setItem('geoip', JSON.stringify(data));
      return data;
    })
    .catch((error) => {
      console.error('Error fetching country code:', error);
      return { country_code: 'US' }; // Return default value 'US' in case of error
    });
}
